export default __webpack_public_path__ + "static/media/filter.58dff21c.svg";